import styled from "styled-components";

export const Subsection = styled.div`
  margin: 5px;
`;
